/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import ActionTypes from '../actions/actionTypes'

const initialState = {
  student_age_for_parent_info: '18',
  theme: 'eden',
  enable_essay: 0,
  essay_question: '',
}

export default (state = initialState, action) => {
  if (action.type === ActionTypes.METADATA) {
    return {
      ...initialState,
      ...action.data,
    }
  } else {
    return state
  }
}
